// Javascript
require("@rails/ujs").start()
require("@rails/activestorage").start()
import '../src/brand/application'

// 画像読み込み設定
const images = require.context('../images', true);
const imagePath = (name) => images(name, true)

// SASS
import '../stylesheets/brand/application.scss'


// DOMContentLoadedイベントを使用して、DOMの読み込みが完了したら実行
document.addEventListener('DOMContentLoaded', function() {
  // 要素の取得をキャッシュ
  const statementElements = document.querySelectorAll('.text-statement-animation');
  const scrollElements = document.querySelectorAll('.text-animation, .mask-bg, .bg-crossline,.logo-history__items--old,.logo-history__items--new,.statement-image,.color-item--red,.color-item--blue,.color-item--black,.logo-image__items,.d-container,.bl_mantle-wrap');
  let windowHeight = window.innerHeight;

  let statementStarted = false;
  let statementIndex = 0;
  let scrollIndex = 0;
  let isAnimatingScroll = false;
  let scrollTimeout = null;

  // スロットリング関数
  function throttle(callback, delay) {
      let lastCall = 0;
      return function(...args) {
          const now = Date.now();
          if (now - lastCall >= delay) {
              lastCall = now;
              callback(...args);
          }
      };
  }

  // ステートメント要素をアクティブにする
  function activateStatementElements() {
      if (statementIndex >= statementElements.length) return;

      const element = statementElements[statementIndex];
      element.classList.add('active');

      // タイマーをセット
      setTimeout(() => {
          statementIndex++;
          activateStatementElements(); // 再帰的に次の要素を処理
      }, 500);
  }

  // 最初のステートメント要素が見えているかチェック
  function checkFirstStatementInView() {
      if (statementStarted || statementElements.length === 0) return;

      const firstElem = statementElements[0];
      const rect = firstElem.getBoundingClientRect();

      if (rect.top < windowHeight) {
          statementStarted = true;
          activateStatementElements();
      }
  }

  // スクロール要素のアクティブ化
  function activateScrollElements() {
      if (isAnimatingScroll || scrollIndex >= scrollElements.length) return;

      const element = scrollElements[scrollIndex];
      const rect = element.getBoundingClientRect();

      if (rect.top < windowHeight) {
          element.classList.add('active');
          isAnimatingScroll = true;

          // アニメーション間隔を管理
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
              scrollIndex++;
              isAnimatingScroll = false;
              activateScrollElements(); // 次の要素をチェック
          }, 500);
      }
  }

  // スクロールイベントをスロットリング
  const handleScroll = throttle(() => {
      checkFirstStatementInView();
      activateScrollElements();
  }, 100);

  // スクロールイベントリスナー
  window.addEventListener('scroll', handleScroll, { passive: true });

  // ウィンドウリサイズ時に高さを更新
  window.addEventListener('resize', () => {
      windowHeight = window.innerHeight;
      handleScroll();
  }, { passive: true });

  // 初回ロード時にも確認
  checkFirstStatementInView();
  activateScrollElements();
});


// ページのスクロール位置の復元を手動にし、ページの再読み込みや戻る/進む操作時に自動的にスクロール位置を復元しないようにする
history.scrollRestoration = "manual";

// ページがリロードされる直前にスクロール位置をリセット
window.addEventListener('beforeunload', function () {
    window.scrollTo(0, 0);
});
